import { MutationTree } from "vuex";
import { DataPropertyImplementationState, DataPropertyImplementation } from "./model";

const mutations: MutationTree<DataPropertyImplementationState> = {
  setDataPropertyImplementations(state, dataPropertyImplementations: DataPropertyImplementation[]) {
    state.dataPropertyImplementations = dataPropertyImplementations
  },
  addDataPropertyImplementation(state, dataPropertyImplementation: DataPropertyImplementation) {
    state.dataPropertyImplementations.push(dataPropertyImplementation)
  },
  updateDataPropertyImplementation(state, dataPropertyImplementation: DataPropertyImplementation) {
    const index = state.dataPropertyImplementations.findIndex(c => c.id === dataPropertyImplementation.id);
    if(index !== -1) {
      state.dataPropertyImplementations.splice(index, 1, dataPropertyImplementation);
    }
  },
  deleteDataPropertyImplementation(state, id: string) {
    state.dataPropertyImplementations = state.dataPropertyImplementations.filter(dataPropertyImplementation => dataPropertyImplementation.id !== id)
  }
}

export default mutations;
